import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import {
  ResourceShareHashRequestInterface,
  ResourceShareHashResponseInterface,
} from '../types/resourse-share-hash-interface'
import { RESOURCE_SHARE_HASH_PATH } from '../api'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import useUser from 'shared/hooks/use-user'

export const useShareHash = (
  data: ResourceShareHashRequestInterface,
  shouldFetch: boolean = false,
) => {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.post,
    ResourceShareHashResponseInterface,
    ResourceShareHashRequestInterface
  >({
    method: RequestMethodsEnum.post,
  })

  const generateShareHash = async () => {
    return await fetcher(RESOURCE_SHARE_HASH_PATH, data)
  }

  const { data: hash } = useControlledSwr(
    () => {
      if (!user) return

      return [RESOURCE_SHARE_HASH_PATH, data.resourceType, data.resourceId]
    },
    generateShareHash,
    undefined,
    shouldFetch,
  )

  return {
    hash,
  }
}
